export default __webpack_public_path__ + "media/images/icons/new-vimeo-2859c446772fc937782c47b491395600.svg";